module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-003"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("THE SCANDAL OF DIVISION"), _c('br')]), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=1%20Corinthians+1:10-16&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("1 CORINTHIANS 1:10-16")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW:")])]), _vm._v(" The Corinthian church was divided into factions (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v("). Paul wanted them to be united in the teaching he had given them (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER")]), _vm._v("). Some were making Christ the head of a faction (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v("), and thereby in their disunity rejecting Christ himself (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR")]), _vm._v("). Baptism, the sacrament of unity, had become the point of division. The efficacy of baptism lies in the one whose name is invoked in the baptism (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v("). In addition to addressing these great issues of truth and unity, the Fathers speculated about details, such as whether Chloe was a family (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR")]), _vm._v("), a person or a place, or had some symbolic reference (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER")]), _vm._v(").")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-041"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:10a "), _c('i', [_vm._v("An Appeal for Unity")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ET ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HERE ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISSENSIONS.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("The visible church is a mixed body, consisting of both righteous and unrighteous people. This is why Paul praises some of its members and criticizes others. The person who agrees with the right doctrine and the church’s teaching concerning the Father, Son and Holy Spirit, as well as with the dispensation concerning us, with resurrection and judgment, and who follows the rules of the church is not in schism. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON 1 ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 1.4.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN43",
      "id": "ap_NFIN43-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPEAL IN ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST’S ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AME.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("Paul was right to add the name of Christ here, because that is what the Corinthians were really rejecting. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 167.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN44",
      "id": "ap_NFIN44-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-042"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:10b "), _c('i', [_vm._v("United in Mind and Judgment")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NITED IN ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HINKING.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("Paul prays that the Corinthians will all think one thing, namely, that those who have been born again are children of God. He wants them to be perfectly united in the teaching which he had given to them. He challenges them to think this way and to defend his teaching. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN45",
      "id": "ap_NFIN45-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NITED IN ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDGMENT.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("It is possible to agree on a form of words but still harbor dissent, which is why Paul speaks the way he does here. It is also possible to share the same opinion with someone but not the same feelings. For example, it is possible to be united in faith without being united in love. This is why Paul says that we must be united both in mind and in judgment. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 3.2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN46",
      "id": "ap_NFIN46-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-043"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("1:11 "), _c('i', [_vm._v("A Report from Chloe")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HETHER ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HLOE ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S A ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LACE.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("Some people think that “Chloe’s people” are those who remain faithful and bear fruit in the faith of Christ. Others think that Chloe is a place, as if one were to say “Antioch’s people,” for example. But others think that she was a woman devoted to God, in whose company there were many faithful worshipers. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN47",
      "id": "ap_NFIN47-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSONALLY ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DENTIFIED.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Paul is careful to mention who his informers are without singling out one particular person. This gives his criticisms plausibility without allowing the Corinthians to direct their feelings toward any one person. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 3.3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN48",
      "id": "ap_NFIN48-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HETHER ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HLOE ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S A ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMILY.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("Perhaps there was a family at Corinth called Chloe, but Paul does not give any details so as not to reveal their identity and start more quarreling. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 168.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN49",
      "id": "ap_NFIN49-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-044"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:12 "), _c('i', [_vm._v("Factions Within the Church")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTH ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD A ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORY OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTISANSHIP.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEMENT OF ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME: ")]), _vm._v("Inspired by God, Paul wrote to you concerning himself and Cephas and Apollos, because even then you were given to faction. But that factiousness involved you in less guilt, because then you were partisans of highly reputed apostles and of those commended by them. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 47.3-4.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN50",
      "id": "ap_NFIN50-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOD ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACHERS. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("Paul exposes their error without mentioning the names of the people responsible. The men whom he names here were all good teachers, but by alluding to them in this way he is really getting at the false apostles. For if the Corinthians were not to boast of their devotion to any of these men, how much more would this be true in the case of false teachers, whose corrupt doctrine he refers to next? C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN51",
      "id": "ap_NFIN51-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST THE ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAD OF A ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACTION?")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("The quarreling at Corinth was not over trivial matters but over something fundamental. Even those who said they were of Christ were at fault, because they were implicitly denying this to others and making Christ the head of a faction rather than the head of the whole church. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 3.5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN52",
      "id": "ap_NFIN52-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDICULOUS ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONFLICT.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("In reality the Corinthians called themselves after other teachers, but Paul uses his own name and that of Apollos and Peter in order to make his point. By adding the name of Christ to the rest, he showed them how ridiculous the whole conflict was. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 168.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN53",
      "id": "ap_NFIN53-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-045"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:13 "), _c('i', [_vm._v("Is Christ Divided?")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECOMES ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVIDED.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("By believing different things about Christ, the people have divided him. One person thought that Christ was a mere man, another that he was only God. One says that he was foretold by the prophets, while another denies it.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Paul starts with himself, so that nobody will think that he is disparaging the status of others. If Christ died for us, how can we attribute his grace and blessing to men, thereby doing him a grave injustice? C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN54",
      "id": "ap_NFIN54-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("Q"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UESTION ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HETORICAL.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Whenever Paul uses rhetorical questions, as he "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("does here, he implies that the whole argument is absurd. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 3.5.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN55",
      "id": "ap_NFIN55-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-046"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:14 "), _c('i', [_vm._v("Paul Baptized Only Crispus and Gaius")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAIMING ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APTISM IN THE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RONG ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("These Corinthians were like the Novatianists and the Donatists of today, who claim baptism for themselves and do not recognize anybody else’s. Those who are so baptized glory in the names of Novatian and Donatus, having been deprived of the name of Christ. Crispus and Gaius are called as witnesses, because although they were baptized by Paul, they never suggested that he should be given any glory because of it. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN56",
      "id": "ap_NFIN56-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AME ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NVOKED IN ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APTISM.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("The greatness of baptism does not lie in the baptizer but in the one whose name is invoked in the baptism. Furthermore, although baptism is important and even necessary in order to obtain the kingdom, still it is much less than preaching the gospel. A person of no singular excellence can baptize, but only the truly gifted can preach the gospel. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 3.6.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN57",
      "id": "ap_NFIN57-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-047"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:15-16"), _c('i', [_vm._v(" Baptized in Paul’s Name?")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEKING ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LORY.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Paul downplays his own role in order to show that he was not seeking honor or glory for himself. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 3.6.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN58",
      "id": "ap_NFIN58-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0971c086","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap4.vue
// module id = 90
// module chunks = 0